module.exports = __webpack_public_path__ + "static/img/logoText.fe85849a.png";